/**
 * 考试列表
 * @author jzhu
 * @date 2020-02-04
 */

import React from "react";
import {connect} from "dva";
import {templateConfig, reduxTemplateConfig} from "./config";

import {framework_tool, component_tool} from '@/tool';
import {WizTableForm} from "@/containers/common";
import { handleExportHeader } from '@/utils/handleTabelHeaderUtils';
let {WizContainer, WizReduxTemplate,modelUtils} = framework_tool;
let { WizBrowserExport} = component_tool;
const _getValue = (type, key) => {
  const values = {
    status: {
      0: '草稿',
      1: '已发布',
      2: '已关闭',
    },
    face: {
      1: '已开启',
      0: '未开启',
    },
    scoreRule: {
      0: '最高分',
      1: '平均分',
    },
  }
  return values[type][key]
}

class StudentAbilityList extends WizContainer {
  componentName = 'studentAbilityList';

  constructor(props) {
    super(props);
    this.state = {
    }
  }

  _handleFile(nextProps, nextState, key) {
    let o = nextProps[key]
    if (o['success']) {
      let headList = o.data['headList']
      let dataList = o.data['dataList']
      WizBrowserExport({
        title: '学员岗位能力评估详情',
        sheetName: '学员岗位能力评估详情',
        columns: handleExportHeader(headList).filter((_, index) => index),
        rows: dataList,
        filename: '学员岗位能力评估详情.xlsx',
      })

      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _handleByTemp(nextProps, nextState, key) {
    let o = nextProps[key]
    if (o['success']) {
      wizNotice.success(o['msg']);
      return true;
    } else {
      wizNotice.error(o['msg']);
      return false;
    }
  }
  _handleByListByPageTemp(nextProps, nextState, key) {
    let o = nextProps[key]
    if (o['success']) {
    let result = o['data']['records']
    if(result instanceof Array && result.length>0){
      let list = result[0]['list']
      nextState['abilityItem'] = list

      for (let index = 0; index < result.length; index++) {
        const element = result[index];
        element['list'].forEach(info => {
        element[`abilityItemId${info['abilityItemId']}`] = info['score']
        });
      }
    
    }
      return true;
    } else {
      wizNotice.error(o['msg']);
      return false;
    }
  }

  /**
   * 页面动作操作后进行提示
   * @param nextProps
   * @param nextState
   * @param key
   * @returns {boolean}
   * @private
   */
  _handleStudentAbility(nextProps, nextState, key) {
    let o = nextProps[key];
    if (o['success']) {
      wizNotice.success(o['msg']);
      return true;
    } else {
      wizNotice.error(o['msg']);
      return false;
    }
  }

  _render() {
    const examTempConfig = WizTableForm.Config.examTemp(this, {apiParams: {state: 1}});
    let _templateConfig = templateConfig({
      self:this,
    })
    let _reduxTemplateCofig = reduxTemplateConfig({
      templateConfig: _templateConfig,
      apiDataFormat: {
        export: this._handleFile,
        list:this._handleByListByPageTemp,
        delete:this._handleStudentAbility
      },
    });
    return <>
      <WizReduxTemplate {..._reduxTemplateCofig} />
    </>
  }
}

const mapStateToProps = (state, ownProps) => {
  const { studentAbilityItem } = state;
  const getListByPage = modelUtils.getModelEntity(studentAbilityItem, "studentAbilityItem@list");

  let result = getListByPage['data']['records']
  let list
  if(result instanceof Array && result.length>0){
     list = result[0]['list']

  } 
  return {
    abilityItem: list,
  }
};

export default connect(mapStateToProps)(StudentAbilityList);
